
/** 视口方向导航器公开事件的有限类型集合。 */
export const ViewportGizmoEventType = {
  /** 用户选中中央面、边或角对应的标准视图。 */
  StandardViewSelected: 'standard-view-selected',
  /** 用户触发外部三角或弧形按钮对应的相机动作。 */
  ControlActionTriggered: 'control-action-triggered',
  /** 用户开始拖动中央方向立方体。 */
  OrbitDragStarted: 'orbit-drag-started',
  /** 用户拖动中央方向立方体产生新的角度增量。 */
  OrbitDragChanged: 'orbit-drag-changed',
  /** 用户完成、取消或因释放而结束方向立方体拖动。 */
  OrbitDragEnded: 'orbit-drag-ended',
  /** 导航器当前悬停目标发生变化。 */
  HoverChanged: 'hover-changed',
} as const;

/** 视口方向导航器公开事件类型。 */
export type ViewportGizmoEventType =
  (typeof ViewportGizmoEventType)[keyof typeof ViewportGizmoEventType];

